import React from 'react';
import './OnboardingIntro.css';
import BrandlyLogo from '../../assets/BrandlyLogo.png';

const OnboardingIntro = ({ onNext }) => {
  return (
    <div className="onboarding-card">
      <div className="onboarding-header">
        <span className="welcome-text">Welcome to</span>
        <img src={BrandlyLogo} alt="Brandly Logo" className="brandly-logo" />
      </div>

      <p className="onboarding-description">
        Let’s ask you a few quick questions to personalize the AI with your unique writing style and creative goals.
      </p>

      <button className="onboarding-button" onClick={onNext}>Next</button>
    </div>
  );
};

export default OnboardingIntro;
